document.addEventListener("click", function (e) {
  const btn = e.target.closest(".v-btn");
  if (btn) {
    e.preventDefault();
    const popup = document.querySelector(".variant-popup");
    const overlay = document.querySelector(".global-overlay");
    const handle = btn.dataset.productHandle;
    popup.classList.add("active");
    overlay?.classList.add("active");
    popup.dataset.currentHandle = handle;
    popup.innerHTML = `<div class="variant-popup-loading"><div class="loader"><span class="visually-hidden">Loading..</span></div></div>`;
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const localizedRoot = root.endsWith('/') ? root : root + '/';
    fetch(`${localizedRoot}products/${handle}?section_id=variant-popup`)
      .then(res => res.text())
      .then(html => {
        if (popup.dataset.currentHandle !== handle) return;
        popup.innerHTML = `
          <button type="button" class="variant-popup-close">&times;</button>
          ${html}
        `;
        popup.dataset.loaded = "true";
      })
      .catch(err => {
        console.error("Failed to load variant popup:", err);
        if (popup.dataset.currentHandle !== handle) return;

        popup.innerHTML = `
          <button type="button" class="variant-popup-close">&times;</button>
          <p>Something went wrong. Please try again.</p>
        `;
      });
    return;
  }
  const closeBtn = e.target.closest(".variant-popup-close, .popup-done-btn");
  if (closeBtn) {
    const popup = closeBtn.closest(".variant-popup");
    popup.classList.remove("active");
    document.querySelector(".global-overlay")?.classList.remove("active");
    return;
  }
  if (e.target.closest(".global-overlay")) {
    document.querySelectorAll(".variant-popup.active").forEach(popup => {
      popup.classList.remove("active");
    });
    document.querySelector(".global-overlay")?.classList.remove("active");
  }

});